<template>
  <v-card>
    <v-card-title>
      <v-row>
        <v-col lg="6"> Data Rombel </v-col>
        <v-col lg="6" align="right">
          <v-btn
            dark
            color="blue"
            @click="
              req = {};
              modal.create = true;
            "
            v-if="$root.app.isAdmin"
          >
            <v-icon>mdi-plus</v-icon>
            Tambah
          </v-btn>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text>
      <form
        @submit.prevent="
          () => {
            options.page = filter.page = 1;
            get();
          }
        "
      >
        <v-text-field
          label="Search"
          v-model="filter.search"
          @change="
            () => {
              options.page = filter.page = 1;
              get();
            }
          "
          append-icon="mdi-magnify"
        ></v-text-field>
      </form>
      <v-data-table
        :footer-props="{
          'items-per-page-options': [5, 10, 20, 50, 100],
        }"
        disable-sort
        :headers="
          $root.app.isAdmin
            ? [
                {
                  text: 'Rombel',
                  value: 'rombel',
                },
                {
                  text: 'Opsi',
                  value: 'actions',
                },
              ]
            : [
                {
                  text: 'Rombel',
                  value: 'rombel',
                },
              ]
        "
        :items="datas"
        :loading="is.loading"
        loading-text="Loading... Please wait"
        :server-items-length="recordsTotal"
        :options.sync="options"
      >
        <template slot="item.actions" slot-scope="{ item }">
          <v-btn
            icon
            color="blue"
            @click="
              req = item;
              modal.edit = true;
            "
          >
            <v-icon>mdi-pen</v-icon>
          </v-btn>
          <v-btn
            icon
            color="red"
            @click="
              req = item;
              modal.delete = true;
            "
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card-text>

    <v-dialog v-model="modal.create">
      <v-form ref="create" @submit.prevent="store">
        <v-card width="500">
          <v-card-title>Tambah Rombel</v-card-title>
          <v-card-text>
            <v-alert
              dense
              v-show="is.submit"
              text
              icon="mdi-clock-fast"
              border="left"
              color="blue"
              >Menunggu...</v-alert
            >
            <v-text-field
              v-model="req.rombel"
              placeholder="Masukkan Rombel"
              label="Rombel"
              :rules="[(v) => !!v || 'rombel harus diisi']"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-btn type="submit" text color="blue">Simpan</v-btn>
            <v-btn type="button" text color="red" @click="modal.create = false"
              >Batal</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="modal.edit">
      <v-form ref="edit" @submit.prevent="update">
        <v-card width="500">
          <v-card-title>Edit Rombel</v-card-title>
          <v-card-text>
            <v-alert
              dense
              v-show="is.submit"
              text
              icon="mdi-clock-fast"
              border="left"
              color="blue"
              >Menunggu...</v-alert
            >
            <v-text-field
              v-model="req.rombel"
              placeholder="Masukkan Rombel"
              label="Rombel"
              :rules="[(v) => !!v || 'rombel harus diisi']"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-btn type="submit" text color="blue">Simpan</v-btn>
            <v-btn type="button" text color="red" @click="modal.edit = false"
              >Batal</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="modal.delete">
      <v-card width="450">
        <v-form @submit.prevent="destroy">
          <v-card-title>Hapus Rombel</v-card-title>
          <v-card-text>Anda yakin menghapus {{ req.rombel }}?</v-card-text>
          <v-card-actions>
            <v-btn type="submit" text color="blue">Hapus</v-btn>
            <v-btn type="button" text color="red" @click="modal.delete = false"
              >Batal</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      datas: [],
      modal: {
        create: false,
        edit: false,
        delete: false,
      },
      req: {},
      is: {
        loading: true,
        submit: false,
      },
      filter: {
        limit: 10,
        search: "",
        page: 1,
      },
      options: {},
      recordsTotal: 0,
    };
  },
  created() {
    this.get();
    this.getData();
  },
  watch: {
    options(val) {
      this.filter.limit = val.itemsPerPage;
      this.filter.page = val.page;
      this.get();
    },
  },
  methods: {
    get() {
      this.is.loading = true;
      this.$root.app.http.get("/api/rombel", this.filter).then((res) => {
        this.datas = res.data;
        this.recordsTotal = res.recordsTotal;
        this.is.loading = false;
      });
    },
    store() {
      this.is.submit = true;
      if (this.$refs.create.validate()) {
        this.$root.app.http.post("/api/rombel", this.req).then((res) => {
          this.is.submit = false;
          if (res.error) {
            this.$root.app.notif(res.message[0], true);
          } else {
            this.get();
            this.modal.create = false;
            this.$root.app.notif(res.message);
          }
        });
      }
    },
    update() {
      this.is.submit = true;
      if (this.$refs.edit.validate()) {
        this.$root.app.http
          .put("/api/rombel/" + this.req.id, this.req)
          .then((res) => {
            this.is.submit = false;
            if (res.error) {
              this.$root.app.notif(res.message[0], true);
            } else {
              this.get();
              this.modal.edit = false;
              this.$root.app.notif(res.message);
            }
          });
      }
    },
    destroy() {
      this.$root.app.http.del("/api/rombel/" + this.req.id).then((res) => {
        if (res.error) {
          this.$root.app.notif(res.message[0], true);
        } else {
          this.get();
          this.modal.delete = false;
          this.$root.app.notif(res.message);
        }
      });
    },
  },
};
</script>
